export var DocsSectionType;
(function (DocsSectionType) {
    /** Section without any extra containers of behaviors */
    DocsSectionType["plain"] = "Plain";
    /** Section with tabs containers */
    DocsSectionType["tabs"] = "Tabs";
})(DocsSectionType || (DocsSectionType = {}));
